import styled from 'styled-components';

import Button from '../../components/Button';

export const Signature = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;

	@media only screen and (min-width: 601px) {
		background-color: #F5F5F5;
	}

	@media only screen and (max-width: 600px) {
		background-color: white;
	}
`;

Signature.Container = styled.div`
	padding: 16px;

	@media only screen and (min-width: 601px) {
		max-width: 600px;
		background-color: white;
		margin: 2rem auto;
		padding: 32px;
	}
`;

Signature.Actions = styled.div`
	display: flex;
`;

Signature.Title = styled.span`
	font-weight: 500;
	font-size: 24px;
	line-height: 29px;
	color: #26282A;
`;

Signature.SignaturePad = styled.div`
	margin-top: 24px;
`;

Signature.SignaturePad.ButtonGroup = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	width: 100%;
`;

Signature.SignaturePad.InputContainer = styled.div`
	width: min(100vw, 440px);
	height: 214px;
	border: 1px solid #D9E1E8;
	border-radius: 8px;
	border-top-left-radius: 0 !important;
	position: relative;
	margin-bottom: 6.33px;

	@media only screen and (max-width: 600px) {
		width: 100%;
	}
`;

Signature.SignaturePad.TextArea = styled.textarea`
	width: min(100%, 440px);
	height: 211px;
	line-height: normal !important;
	color: #000 !important;
	border: none;
	border-radius: 8px;
	text-align: center;
	font-family: Ephesis !important;
	font-size: 35px !important;
	font-style: normal;
	font-weight: 550;
	resize: none !important;
	padding: 8px !important;
`;

Signature.FooterContainer = styled.div`
	position: fixed;
	bottom: 0;
	background-color: white;
	width: 100%;
	padding: 16px;
`;

Signature.Footer = styled.div`
	display: flex;
	height: 100%;
	flex: 1;
	flex-direction: column;

	@media only screen and (max-width: 600px) {
		justify-content: flex-end;
	}
`;

Signature.Footer.ClearButton = styled(Button)`
	margin-top: 8px;
	display: flex !important;
`;
